import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlayBig = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 94,
	height: 94,
	viewBox: "0 0 94 94",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 47,
			cy: 47,
			r: 47,
			fill: "white",
			fillOpacity: .3
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 47,
			cy: 47,
			r: 35,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M41.9396 61.3612L60.4008 48.3733C60.9707 47.9724 61.0297 47.2747 60.5326 46.815C60.4926 46.778 60.4497 46.7433 60.404 46.7109L41.9428 33.6411C41.3744 33.2387 40.5092 33.2842 40.0103 33.7426C39.791 33.9441 39.67 34.2031 39.67 34.4712V60.5289C39.67 61.1389 40.2831 61.6334 41.0394 61.6334C41.3704 61.6334 41.6902 61.5367 41.9396 61.3612Z",
			fill: "#4D4D54"
		})
	]
});
export default SvgPlayBig;
